import { render, staticRenderFns } from "./StockTrackingList.vue?vue&type=template&id=728218e8&"
import script from "./StockTrackingList.vue?vue&type=script&lang=ts&"
export * from "./StockTrackingList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports